<script lang="ts">
import Layout from "@/Layouts/AppBase.vue";
import MainNavigation from "@/Components/MainNavigation.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        Layout,
        MainNavigation,
    },
});
</script>

<template>
    <Layout>
        <template #navigation>
            <MainNavigation />
        </template>
        <template #content>
            <slot></slot>
        </template>
    </Layout>
</template>
